export default __webpack_public_path__ + "static/media/payment1.b058fdf8.jpg";